export default "__VITE_ASSET__BffDy9tD__"